/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listIncidentNotificationResponsesParamsResponseIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const listIncidentNotificationResponsesParamsCursorMax = 2000;

export const listIncidentNotificationResponsesParamsLimitOneRegExp = new RegExp('^[0-9]+$');
export const listIncidentNotificationResponsesParamsLimitDefault = 50;
export const ListIncidentNotificationResponsesParams = zod.object({
  responseId: zod.uuid().regex(listIncidentNotificationResponsesParamsResponseIdRegExp).optional(),
  cursor: zod.string().min(1).max(listIncidentNotificationResponsesParamsCursorMax).optional(),
  limit: zod
    .union([
      zod.string().regex(listIncidentNotificationResponsesParamsLimitOneRegExp),
      zod.number(),
    ])
    .default(listIncidentNotificationResponsesParamsLimitDefault),
});

export type ListIncidentNotificationResponsesParams = zod.input<
  typeof ListIncidentNotificationResponsesParams
>;
export type ListIncidentNotificationResponsesParamsOutput = zod.output<
  typeof ListIncidentNotificationResponsesParams
>;
